import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';

import PartnerListComponent from "../../components/2.1/partner/PartnerListComponent"
import PartnerFormComponent from "../../components/2.1/partner/PartnerFormComponent";
import PartnerShowComponent from '../../components/2.1/partner/PartnerShowComponent';
import ProjectListComponent from "../../components/2.1/project/ProjectListComponent";
import PartnerBankAccountListComponent from '../../components/2.1/partner/PartnerBankAccountListComponent';
import PartnerBankAccountFormComponent from '../../components/2.1/partner/PartnerBankAccountFormComponent';
import ContactpartnerListComponent from '../../components/2.1/partner/contactpartner/ContactpartnerListComponent';
import ContactpartnerFormComponent from '../../components/2.1/partner/contactpartner/ContactpartnerFormComponent';
import ContactFormComponent from '../../components/2.1/partner/contactpartner/ContactFormComponent';
import ContactpartnerShowComponent from '../../components/2.1/partner/contactpartner/ContactpartnerShowComponent';
import ContactListComponent from '../../components/2.1/partner/contactpartner/ContactListComponent';
import ContactShowComponent from '../../components/2.1/partner/contactpartner/ContactShowComponent';
import PartnerAddressListComponent from '../../components/2.1/partner/partneraddress/PartnerAddressListComponent';
import PartnerAddressFormComponent from '../../components/2.1/partner/partneraddress/PartnerAddressFormComponent';
import PartnerCrmOverviewComponent from '../../components/2.1/partner/PartnerCrmOverviewComponent';

export const PartnerPage = (props) => {
  const {t} = props;

  const history = useHistory();
  const {action, id} = useParams();
  const activeContactId = window.App.urlVars().contactId;
  const [partner, setPartner] = useState({});
  const [contact, setContact] = useState({});
  const normalizedRoles = (localStorage.getItem('roles') || '').toLowerCase();
  const hasCrmAccess = Boolean(localStorage.getItem('module_crm')) && [
    'role_crm_lead_read', 'role_crm_lead_role', 'role_crm_deal_read',
    'role_crm_action_read', 'role_crm_task_read'
  ].some(role => normalizedRoles.includes(role));

  const contactBacklink = activeContactId
    ? `/partner/contact?read=contact&contactId=${activeContactId}`
    : `/partner/contact`;

  const partnerBacklink = id
    ? `/partner/read/${id}`
    : `/partner`;


  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchActive, setDetailedSearchActive] = useState(false);
  const [bankAccountSidebarVisible, setBankAccountSidebarVisible] = useState(false);
  const [editingBankAccountId, setEditingBankAccountId] = useState(null);
  const [partnerAddressSidebarVisible, setPartnerAddressSidebarVisible] = useState(false);
  const [editingPartnerAddressId, setEditingPartnerAddressId] = useState(null);

  useEffect(() => {
    document.title = 'Partner' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('partner')[0]) {
        document.getElementsByClassName('partner')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, []);

  return (
    <div className={"PartnerPage"}>
      {(localStorage.getItem('roles') || '[]').includes('role_partner_read') ? (
        <>
        {(!action || action === 'create' || action === 'update') && (
          <div className={"PageContent p-p-5 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {/* {t('partnerList')} */}
                  {!window.App.urlVars().view && t('partnerList')}
                  {window.App.urlVars().view === 'customer' && t('customerList')}
                  {window.App.urlVars().view === 'vendor_service' && t('vendorServiceList')}
                  {window.App.urlVars().view === 'vendor_material' && t('vendorMaterialList')}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                <span className={"p-mr-2"}>

                </span>
                <Button
                  type="button"
                  label={t('detailedSearch')}
                  icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                  className="p-button-outlined p-mr-2"
                  onClick={() => setDetailedSearchVisible(v => !v)}
                />
                <a onClick={() => {
                  history.push('/partner/create')
                }}
                   className={"p-button  p-button-success p-ml-2"}>
                  <i className={"pi pi-plus"}></i>
                  &nbsp;
                  {t('addPartner')}
                </a>
              </div>
            </div>
            <Panel>
              <PartnerListComponent  view={window.App.urlVars().view} detailedSearchVisible={detailedSearchVisible}
                onDetailedSearchVisibleChange={setDetailedSearchVisible}
                onDetailedSearchActiveChange={setDetailedSearchActive}
                backlink={'/partner'}/>
            </Panel>
          </div>
        )}
        {action === 'contact' && window.App.urlVars().read !== 'contact' && (
          <div className={"PageContent p-p-5 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('contactList')}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <Button
                    type="button"
                    label={t('detailedSearch')}
                    icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                    className="p-button-outlined p-mr-2"
                    onClick={() => setDetailedSearchVisible(v => !v)}
                  />
                  <a
                    onClick={() => {
                      history.push('/partner/contact?create=contact')
                    }}
                    className={"p-button p-button-success p-ml-2"}
                  >
                    <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addContact')}
                  </a>
                </div>
            </div>

            <Panel>
              <ContactListComponent view={window.App.urlVars().view} detailedSearchVisible={detailedSearchVisible}
                onDetailedSearchVisibleChange={setDetailedSearchVisible}
                onDetailedSearchActiveChange={setDetailedSearchActive}/>
            </Panel>
          </div>
        )}
        {action === 'contact' && window.App.urlVars().read === 'contact' && window.App.urlVars().contactId && (
          <div className="PageContent p-p-5 p-mx-auto">
            <div className="p-grid">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {contact?.name}
                </h2>
              </div>

              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                <a
                  onClick={() => {
                    history.push(
                      '/partner/contact?read=contact&contactId=' +
                      window.App.urlVars().contactId +
                      '&create=contactpartner'
                    )
                  }}
                  className="p-button p-button-success p-ml-2"
                >
                  <i className="pi pi-plus"></i>
                  &nbsp;
                  {t('addPosition')}
                </a>
                <a
                  onClick={() => history.push('/partner/contact')}
                  className="p-button p-button-secondary p-ml-2"
                >
                  <i className="pi pi-arrow-left"></i>
                  &nbsp;
                  {t('back')}
                </a>
              </div>
            </div>

            <Panel>
              <TabView className="tabview-header-icon menu" style={{ backgroundColor: 'white', border: 'none' }}>
                <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                  <div className="p-grid">
                    <div className="p-col-12 p-lg-6">
                      <div className="p-grid">
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                            {t('contactData')}
                          </h3>
                        </div>

                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                          <Button
                            icon="pi pi-pencil"
                            className="p-button-warning p-button-sm p-ml-2"
                            label={t('editData')}
                            onClick={() => {
                              history.push('/partner/contact?update=contact&contactId=' + window.App.urlVars().contactId)
                            }}
                          />
                        </div>
                      </div>

                      <ContactShowComponent
                        key={window.App.urlVars().contactId}
                        contactId={window.App.urlVars().contactId}
                        onLoaded={(contact) => setContact(contact || {})}
                      />
                    </div>

                    <div className="p-col-12 p-lg-6">
                      <div className="p-grid">
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                            {t('positions')}
                          </h3>
                        </div>
                      </div>

                      <ContactpartnerListComponent
                        contactId={window.App.urlVars().contactId}
                        
                      />
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </Panel>
          </div>
        )}
          <Sidebar
            position="left"
            showCloseIcon={false}
            visible={
              action === 'contact' &&
              (
                window.App.urlVars().create === 'contact' ||
                window.App.urlVars().update === 'contact'
              )
            }
            closeOnEscape={true}
            style={{width: '780px'}}
            onHide={() => {
              history.push('/partner/contact')
            }}
          >
            <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {window.App.urlVars().update === 'contact'
                      ? t('contactUpdate')
                      : t('contactCreate')}
                  </h2>
                </div>

                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <a
                    onClick={() => {
                      history.push('/partner/contact')
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>

              <Panel>
                <ContactFormComponent
                  contactId={window.App.urlVars().contactId}
                  backlink={'/partner/contact'}
                />
              </Panel>
            </div>
          </Sidebar>
          <Sidebar
            position="left"
            showCloseIcon={false}
            visible={
              action === 'contact' && window.App.urlVars().read === 'contact' &&
              (window.App.urlVars().create === 'contactpartner' || window.App.urlVars().update === 'contactpartner')
            }
            closeOnEscape={true}
            style={{width: '780px'}}
            onHide={() => {
              history.push(contactBacklink)
            }}
          >
            <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('addPosition')}
                  </h2>
                </div>

                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <a
                    onClick={() => {
                      history.push(contactBacklink)
                    }}
                    className={"p-button p-button-secondary p-ml-2"}
                  >
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>

              <Panel>
                <ContactpartnerFormComponent
                  contactId={window.App.urlVars().contactId}
                  backlink={contactBacklink}
                />
              </Panel>
            </div>
          </Sidebar>
          {((action === 'create' || action === 'update' || window.App.urlVars().update === 'partner')) && (localStorage.getItem('roles') || '[]').includes('role_partner_write') && (
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'partner'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/partner')
                       if (action === 'create' || action === 'update') {
                        history.push('/partner')
                       }
                       if (action === 'read' && id && window.App.urlVars().update === 'partner') {
                         history.push(`/partner/read/${id}`)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('partnerUpdate') : t('partnerCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      history.push('/partner')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {/* <PartnerFormComponent backlink={'/partner'}/> */}
                  {(action === 'create' || action === 'update') &&
                    <PartnerFormComponent backlink={'/partner'}/>
                  }
                  {(action === 'read' && id && window.App.urlVars().update === 'partner') &&
                    <PartnerFormComponent partnerId={id} backlink={partnerBacklink}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          )}

        {action === 'read' && id && (localStorage.getItem('roles') || '[]').includes('role_partner_read') && (
        <div className="PageContent p-p-5 p-mx-auto">
          <div className="p-grid">
            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
              <h2 className="p-m-0 p-p-0 text-primary p-d-inline">{partner?.name}</h2>
            </div>
            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              <a onClick={() => history.push('/partner')}
                 className="p-button p-button-secondary p-ml-2">
                <i className="pi pi-arrow-left" /> &nbsp; {t('back')}
              </a>
            </div>
          </div>
          <Panel>
            <TabView className="tabview-header-icon menu" style={{ backgroundColor: 'white', border: 'none' }}>
              <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-4">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('partnerData')}</h3>
                      </div>
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <Button
                          icon="pi pi-pencil"
                          className="p-button-warning p-button-sm p-ml-2"
                          label={t('editData')}
                          onClick={() => history.push(`/partner/read/${id}?update=partner`)}
                        />

                      </div>
                    </div>
                    <PartnerShowComponent key={id} partnerId={id} onLoaded={(partner) => setPartner(partner || {})} />
                  </div>
                  <div className="p-col-12 p-lg-8">
                        <div className="p-grid">
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                              {t('addresses')}
                            </h3>
                          </div>

                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                            {localStorage.getItem('roles')?.toString().includes('role_') && (
                              <Button
                                icon="pi pi-plus"
                                className="p-button-success p-button-sm p-ml-2"
                                label={t('addAddress')}
                                onClick={() => {
                                  setEditingPartnerAddressId(null);
                                  setPartnerAddressSidebarVisible(true);
                                }}
                              />
                            )}
                          </div>
                        </div>

                        <PartnerAddressListComponent
                          partnerId={id}
                          onEdit={(row) => {
                            setEditingPartnerAddressId(row.id);
                            setPartnerAddressSidebarVisible(true);
                          }}
                        />

                        <div className="p-grid p-mt-4">
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                              {t('bankAccountNumbers')}
                            </h3>
                          </div>
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                            {localStorage.getItem('roles')?.toString().includes('role_') && (
                              <Button
                                icon="pi pi-plus"
                                className="p-button-success p-button-sm p-ml-2"
                                label={t('addBankAccount')}
                                onClick={() => {
                                  setEditingBankAccountId(null);
                                  setBankAccountSidebarVisible(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <PartnerBankAccountListComponent
                          partnerId={id}
                          onEdit={(row) => {
                            setEditingBankAccountId(row.id);
                            setBankAccountSidebarVisible(true);
                          }}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  {(localStorage.getItem('roles') || '').toLowerCase().includes('role_project_read') && (
                    <TabPanel header={t('tabProjects')} leftIcon="pi pi-briefcase">
                      <div className="p-grid">
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('partnerProjects')}</h3>
                        </div>
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right" />
                      </div>
                      <ProjectListComponent partnerId={id} />
                    </TabPanel>
                  )}
                  <TabPanel header={t('tabContacts')} leftIcon="pi pi-users">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('extendedContacts')}</h3>
                      </div>
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right" >
                        <Button
                          icon="pi pi-plus"
                          className="p-button-success p-button-sm p-ml-2"
                          label={t('addContact')}
                          onClick={() => history.push(`/partner/read/${id}?create=contactpartner`)}
                        />
                        </div>
                      </div>
                    <ContactpartnerListComponent partnerId={id} source="partner" />
                  </TabPanel>
                  {hasCrmAccess && (
                    <TabPanel header={t('crmPartnerTab')} leftIcon="pi pi-chart-line">
                      <PartnerCrmOverviewComponent partnerId={id} partner={partner}/>
                    </TabPanel>
                  )}
            </TabView>
          </Panel>
        </div>
      )}

      {action === 'read' && id && (
        <Sidebar
          position="left"
          showCloseIcon={false}
          visible={window.App.urlVars().create === 'contactpartner' || window.App.urlVars().update === 'contactpartner'}
          closeOnEscape={true}
          style={{ width: '780px' }}
          onHide={() => {
            history.push(partnerBacklink);
          }}
        >
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {window.App.urlVars().update === 'contactpartner'
                    ? t('contactUpdate')
                    : t('contactCreate')}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                <a
                  onClick={() => history.push(partnerBacklink)}
                  className={"p-button p-button-secondary p-ml-2"}
                >
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  {t('back')}
                </a>
              </div>
            </div>
            <Panel>
              {window.App.urlVars().contactPartnerId ? (
                <ContactpartnerFormComponent
                  partnerId={id}
                  backlink={partnerBacklink}
                />
              ) : (
                <ContactFormComponent
                  partnerId={id}
                  backlink={partnerBacklink}
                />
              )}
            </Panel>
          </div>
        </Sidebar>
      )}


      {action === 'read' && id && (
        <Sidebar
          position="left"
          showCloseIcon={false}
          visible={window.App.urlVars().read === 'contactpartner'}
          closeOnEscape={true}
          style={{ width: '95%' }}
          onHide={() => {
            history.push(`/partner/read/${id}`);
          }}
        >
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {contact?.name}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                <a
                  onClick={() => history.push(`/partner/read/${id}`)}
                  className={"p-button p-button-secondary p-ml-2"}
                >
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  {t('back')}
                </a>
              </div>
            </div>
            <Panel>
            <TabView className="tabview-header-icon menu" style={{ backgroundColor: 'white', border: 'none' }}>
              <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6">
                    <div className="p-grid">
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('contactData')}</h3>
                      </div>
                      <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                        <Button
                          icon="pi pi-pencil"
                          className="p-button-warning p-button-sm p-ml-2"
                          label={t('editData')}
                          onClick={() => {
                            history.push('/partner/read/' + id + '?read=contactpartner&update=contactpartner&contactId=' + activeContactId)
                          }}
                        />

                      </div>
                    </div>
                    <ContactpartnerShowComponent key={id} partnerId={id} onLoaded={(contact) => setContact(contact || {})} />
                  </div>
                  <div className="p-col-12 p-lg-6">
                        <div className="p-grid">
                          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                              {t('companyPosition')}
                            </h3>
                          </div>
                          {/* <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                            {localStorage.getItem('roles')?.toString().includes('role_') && (
                              <Button
                                icon="pi pi-plus"
                                className="p-button-success p-button-sm p-ml-2"
                                label={t('new')}
                                onClick={() => {
                                }}
                              />
                            )}
                          </div> */}
                        </div>
                        <ContactListComponent
                          partnerId={id}
                          onEdit={(row) => {
                          }}
                        />
                      </div>
                    </div>
                  </TabPanel>
            </TabView>
          </Panel>
          </div>
        </Sidebar>
      )}

      
      {action === 'read' && id && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={bankAccountSidebarVisible}
              closeOnEscape={true}
              style={{ width: '780px' }}
              onHide={() => {
                setBankAccountSidebarVisible(false);
                setEditingBankAccountId(null);
              }}
            >
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {editingBankAccountId ? t('bankAccountNumberUpdate') : t('bankAccountNumberCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a
                      onClick={() => {
                        setBankAccountSidebarVisible(false);
                        setEditingBankAccountId(null);
                      }}
                      className={"p-button  p-button-secondary p-ml-2"}
                    >
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PartnerBankAccountFormComponent
                    partnerId={id}
                    bankAccountId={editingBankAccountId}
                    goback={false}
                    backlink={`/partner/read/${id}`}
                  />
                </Panel>
              </div>
            </Sidebar>
          )}
          {action === 'read' && id && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={partnerAddressSidebarVisible}
              closeOnEscape={true}
              style={{ width: '780px' }}
              onHide={() => {
                setPartnerAddressSidebarVisible(false);
                setEditingPartnerAddressId(null);
              }}
            >
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {editingPartnerAddressId ? t('addressUpdate') : t('addressCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a
                      onClick={() => {
                        setPartnerAddressSidebarVisible(false);
                        setEditingPartnerAddressId(null);
                      }}
                      className={"p-button  p-button-secondary p-ml-2"}
                    >
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <PartnerAddressFormComponent
                    partnerId={id}
                    partnerType={partner?.type}
                    partnerAddressId={editingPartnerAddressId}
                    goback={false}
                    backlink={`/partner/read/${id}`}
                  />
                </Panel>
              </div>
            </Sidebar>
          )}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'partner'}
            closeOnEscape={true}
            style={{width: '100%', height: '80%'}}
            onHide={() => {
              const backlink = window.App.urlVars().backlink || window.App.urlVars().return;
              history.push(backlink ? decodeURIComponent(backlink) : '/partner/contact');
            }}
          >
            <div className={"p-grid p-mt-3"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('partnerSearch')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

              </div>
            </div>
            <Panel>
              <PartnerListComponent
                view={"search"}
                backlink={
                  window.App.urlVars().backlink
                    ? decodeURIComponent(window.App.urlVars().backlink)
                    : '/partner/contact'
                }
              />
            </Panel>
          </Sidebar>
        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
          Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
          }
        </p>
      )}
    </div>
  )
}
export default withTranslation('common')(PartnerPage);
